import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { LogIn, LogOut, Loader, CheckCircle } from 'lucide-react';

const AuthButton = () => {
  const {
    isAuthenticated,
    user,
    login,
    logout,
    isLoading,
    validandoAcceso,
    accesoAutorizado,
    datosUsuarioAutorizado
  } = useAuth();

  // Estado de carga (login/logout)
  if (isLoading) {
    return (
      <button
        disabled
        className="flex items-center gap-2 px-4 py-2 bg-gray-300 text-gray-600 rounded"
      >
        <Loader className="w-4 h-4 animate-spin" />
        Cargando...
      </button>
    );
  }

  // Usuario NO autenticado
  if (!isAuthenticated) {
    return (
      <button
        onClick={login}
        className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        <LogIn className="w-4 h-4" />
        Iniciar Sesión
      </button>
    );
  }

  // Usuario autenticado (mostrar estado de validación)
  if (isAuthenticated) {
    return (
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          {/* En validación */}
          {validandoAcceso && (
            <div className="flex items-center gap-2 px-3 py-2 bg-yellow-100 text-yellow-700 rounded text-sm">
              <Loader className="w-4 h-4 animate-spin" />
              Validando...
            </div>
          )}

          {/* Acceso autorizado */}
          {!validandoAcceso && accesoAutorizado && (
            <div className="flex items-center gap-2 px-3 py-2 bg-green-100 text-green-700 rounded">
              <CheckCircle className="w-4 h-4" />
              <span className="text-sm font-medium">
                {datosUsuarioAutorizado?.nombre || user?.name || user?.username}
              </span>
            </div>
          )}

          {/* Acceso denegado */}
          {!validandoAcceso && !accesoAutorizado && (
            <div className="flex items-center gap-2">
              <span className="text-sm text-red-600 font-medium">
                Sin acceso
              </span>
              <button
                onClick={logout}
                className="flex items-center gap-2 px-3 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
              >
                <LogOut className="w-4 h-4" />
                Cambiar usuario
              </button>
            </div>
          )}
        </div>

        {/* Botón de logout (si está autenticado) */}
        {accesoAutorizado && (
          <button
            onClick={logout}
            className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Cerrar Sesión
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default AuthButton;
